import { useSelector } from "react-redux";
import { HEALTH_FUND_OPTIONS } from "../usePatientForm";
import { selectHasPermission } from "../../../../store/slices/authSlice";
import { NoAccessState } from "../../../shared/access";

/**
 * רקע רפואי — diagnoses, health fund, medications, previous treatments and
 * clinical notes. Everything here is optional.
 */
function MedicalStep({ form }) {
  const { formData, handleChange, isSpeechTherapist } = form;
  // clinical.viewSensitive: legacy therapists default TRUE; only an explicit
  // false hides the field (and its value never reaches the payload).
  const canViewSensitive = useSelector(selectHasPermission("clinical.viewSensitive"));

  return (
    <div className="pat-wiz-step-panel" key="step-medical">
      <h3 className="section-title">רקע רפואי וקליני</h3>

      <div className="form-group">
        <label>אבחנות קיימות</label>
        <textarea
          value={formData.diagnoses}
          onChange={(e) => handleChange("diagnoses", e.target.value)}
          placeholder="למשל: ASD, ADHD, עיכוב שפתי..."
          rows={2}
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>קופת חולים</label>
          <select
            value={formData.healthFund}
            onChange={(e) => handleChange("healthFund", e.target.value)}
          >
            <option value="">בחר קופה</option>
            {HEALTH_FUND_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label>גורם מפנה</label>
          <input
            type="text"
            value={formData.referringDoctor}
            onChange={(e) => handleChange("referringDoctor", e.target.value)}
            placeholder="שם הרופא / הגורם המפנה"
          />
        </div>
      </div>

      <div className="form-group">
        <label>אלרגיות או רגישויות</label>
        <input
          type="text"
          value={formData.allergies}
          onChange={(e) => handleChange("allergies", e.target.value)}
          placeholder="פרט אלרגיות אם קיימות"
        />
      </div>

      <div className="form-group">
        <label>תרופות קבועות</label>
        <textarea
          value={formData.medications}
          onChange={(e) => handleChange("medications", e.target.value)}
          placeholder="פרט תרופות שהמטופל נוטל באופן קבוע"
          rows={2}
        />
      </div>

      <div className="form-group">
        <label>טיפולים קודמים</label>
        <textarea
          value={formData.previousTreatments}
          onChange={(e) => handleChange("previousTreatments", e.target.value)}
          placeholder="איפה היה מטופל בעבר?"
          rows={2}
        />
      </div>

      <div className="form-group">
        <label>מסגרת חינוכית</label>
        <input
          type="text"
          value={formData.educationalFramework}
          onChange={(e) => handleChange("educationalFramework", e.target.value)}
          placeholder="שם הגן / בית הספר"
        />
      </div>

      {isSpeechTherapist && (
        <div className="form-group">
          <label>תוצאות בדיקת שמיעה</label>
          <textarea
            value={formData.hearingTestResults}
            onChange={(e) => handleChange("hearingTestResults", e.target.value)}
            placeholder="סוג הבדיקה, תאריך, ממצאים, המלצות..."
            rows={3}
          />
        </div>
      )}

      <h3 className="section-title">הערות קליניות</h3>

      {canViewSensitive === false ? (
        <NoAccessState size="inline" message="מידע רפואי — אין הרשאה" />
      ) : (
        <div className="form-group">
          <label>הערות קליניות כלליות</label>
          <textarea
            value={formData.clinicalNotes}
            onChange={(e) => handleChange("clinicalNotes", e.target.value)}
            placeholder="רקע כללי שלא משתנה בכל מפגש..."
            rows={3}
          />
        </div>
      )}
    </div>
  );
}

export default MedicalStep;
